import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';

/**
 * Prevents leading/trailing spaces in form controls while typing.
 * Preserves internal/middle spaces.
 * 
 * @param subscriptions Array to store subscriptions for cleanup.
 * @param form FormGroup instance.
 * @param controlNames Array of control names to apply trimming.
 */
// Subscribe only to clean input after typing is done (optional: use debounce)
export function trimEdgeSpaces(subscriptions: Subscription[], form: FormGroup, controlNames: string[]) {
    controlNames.forEach(name => {
        const control = form.get(name);
        if (!control) return;

        const sub = control.valueChanges.subscribe(value => {
            if (typeof value === 'string') {
                // Only remove leading spaces while typing
                const trimmedStart = value.replace(/^\s+/, '');
                if (trimmedStart !== value) {
                    control.setValue(trimmedStart, { emitEvent: false });
                }
            }
        });

        subscriptions.push(sub);
    });
}

// Later, on blur or form submit, remove trailing spaces too
export function trimEdgeSpacesOnBlurOrSubmit(control: AbstractControl) {
    if (typeof control.value === 'string') {
        control.setValue(control.value.trim(), { emitEvent: false });
    }
}

/**
 * Validator: Disallow leading space only.
 */
export function noLeadingSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) return null;
        return value.startsWith(' ') ? { leadingSpace: true } : null;
    };
}


export function capitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}